module.exports = __webpack_public_path__ + "img/2.bbd0f419.png";